var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vx-card',{staticClass:"compact-card"},[_c('div',{staticClass:"header header-title"},[_vm._t("header")],2),_c('div',[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }